import type { Node } from 'reactflow';

export enum NodeType {
  Vision = 'Vision',
  Objective = 'Objective',
  Activity = 'Activity',
  Risk = 'Risk',
  Opportunity = 'Opportunity',
  Resource = 'Resource',
  KPI = 'KPI',
  Stakeholder = 'Stakeholder',
}

export enum NodeStatus {
  Active = 'Active',
  Paused = 'Paused',
  Archived = 'Archived',
  ToReview = 'ToReview',
}

export type Priority = 1 | 2 | 3 | 4 | 5;

export interface NodeData {
  title: string;
  description?: string;
  type: NodeType;
  status: NodeStatus;
  priority: Priority;
  color: string;
  canvasId: string;
  createdById: string;
  tags?: string[];
  createdAt: string;
  updatedAt: string;
  budgetPlanned?: number | null;
  budgetSpent?: number | null;
  effortPlannedDays?: number | null;
  effortSpentDays?: number | null;
  progress?: number | null;
}

export type StratMapNode = Node<NodeData>;

export interface CreateNodePayload {
  title: string;
  description?: string;
  type: NodeType;
  status?: NodeStatus;
  priority?: Priority;
  canvasId: string;
  positionX: number;
  positionY: number;
  budgetPlanned?: number | null;
  budgetSpent?: number | null;
  effortPlannedDays?: number | null;
  effortSpentDays?: number | null;
  progress?: number | null;
}

export interface UpdateNodePayload {
  title?: string;
  description?: string;
  status?: NodeStatus;
  priority?: Priority;
  positionX?: number;
  positionY?: number;
  tags?: string[];
  budgetPlanned?: number | null;
  budgetSpent?: number | null;
  effortPlannedDays?: number | null;
  effortSpentDays?: number | null;
  progress?: number | null;
}

export const NODE_TYPE_COLORS: Record<NodeType, string> = {
  [NodeType.Vision]: '#8B5CF6',
  [NodeType.Objective]: '#3B82F6',
  [NodeType.Activity]: '#22C55E',
  [NodeType.Risk]: '#EF4444',
  [NodeType.Opportunity]: '#FBBF24',
  [NodeType.Resource]: '#6B7280',
  [NodeType.KPI]: '#14B8A6',
  [NodeType.Stakeholder]: '#EC4899',
};

export const NODE_STATUS_LABELS: Record<NodeStatus, string> = {
  [NodeStatus.Active]: 'Actif',
  [NodeStatus.Paused]: 'En pause',
  [NodeStatus.Archived]: 'Archivé',
  [NodeStatus.ToReview]: 'À réviser',
};
